import { Component, OnInit } from '@angular/core';
import { FundinstitutionService } from '../service/fundinstitution.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-fundinstitution-create',
  templateUrl: './fundinstitution-create.component.html',
  styleUrls: ['./fundinstitution-create.component.css']
})
export class FundinstitutionCreateComponent implements OnInit {

  obj: any = {
    FundInstitutionId: null,
    IncomeTaxAuthorizationNumber: null,
    Name: null,
    Type: null,
    InstitutionName: null,
    IdentityNumber: null,
    BankName: null,
    BankNumber: null,
    BankBranch: null,
    BranchNumber: null,
    AccountNumber: null,
    EmailFinanceSupport: null,
    Notes: null,
    Active: true
  }
  msgs: any[] = [];
  listBank: any[] = [];
  selectedBankNumber: any = null;

  constructor(private dataService: FundinstitutionService) { }

  ngOnInit() {
    this.dataService.getBank().subscribe((result: any) => {
      this.listBank = result;
      this.listBank.unshift({ label: 'בחירה', value: null });
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת בנקים ');
      });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  onSubmit(myForm: NgForm): any {
    if (myForm.valid) {
      this.obj.IncomeTaxAuthorizationNumber = this.obj.IncomeTaxAuthorizationNumber == null ? "" : parseInt(this.obj.IncomeTaxAuthorizationNumber);
      this.obj.Name = this.obj.Name == null ? "" : this.obj.Name;
      this.obj.Type = this.obj.Type == null ? "" : this.obj.Type;
      this.obj.InstitutionName = this.obj.InstitutionName == null ? "" : this.obj.InstitutionName;
      this.obj.IdentityNumber = this.obj.IdentityNumber == null ? "" : this.obj.IdentityNumber;
      this.obj.BankName = this.obj.BankName == null ? "" : this.obj.BankName;
      this.obj.BankNumber = this.selectedBankNumber;
      this.obj.BankBranch = this.obj.BankBranch == null ? "" : this.obj.BankBranch;
      this.obj.BranchNumber = this.obj.BranchNumber == null ? "" : parseInt(this.obj.BranchNumber);
      this.obj.AccountNumber = this.obj.AccountNumber == null ? "" : parseInt(this.obj.AccountNumber);
      this.obj.EmailFinanceSupport = this.obj.EmailFinanceSupport == null ? "" : this.obj.EmailFinanceSupport;
      this.obj.Notes = this.obj.Notes == null ? "" : this.obj.Notes;
      this.dataService.post(this.obj).subscribe((result: any) => {
        if (result = "Success") {
          this.showMessage('success', '', 'נשמר בהצלחה');
          myForm.reset();
        }
        else {
          this.showMessage('error', '', 'תקלה לא צפויה בשמירה');
        }
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה לא צפויה בשמירה');
      });
    }
    else {
      this.showMessage('error', '', 'לא ניתן לבצע שמירה');
    }
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/fundinstitution-create/fundinstitution-create.component.ts